<style lang="less" scoped>
@import '../../../style/common/variable';
.hzxmKCPList{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 40px;}
.box{width: 1180px;margin:auto;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 24px;color: rgb(25, 159, 248);}
.recommendation{margin-top: 24px;height: 30px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.swipergroup{margin-top: 20px;}
.mining{margin-top: 44px;height: 30px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.search{margin-left: -30px;margin-bottom: 20px;}
ul{list-style: none;width: 1160px;margin-left: -30px;}
  li:nth-child(1) {background-color: #ECF6FF;line-height: 28px;font-size: 18px;display: flex;text-align: left;float: left;
  .first{width: 100px;margin-left: 150px;}
  .second{width:80px;margin-left: 190px;}
  .third{width: 80px;margin-left: 60px;}
  .fourth{width: 80px;margin-left: 80px;}
  .fifth{width: 60px;margin-left: 114px;}
  .sixth{width: 96px;margin-left: 80px;}
}
li:nth-child(n+2){height: 30px;border-bottom: 1px solid #f0f0f0;display: flex;padding-top: 10px;cursor: pointer;text-align: center;float: left;
  .first{width: 380px;text-align: left;margin-left: 16px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .second{width: 40px;margin-left: 60px;}
  .third{width: 40px;margin-left: 100px;}
  .fourth{width: 160px;margin-left: 60px;}
  .fifth{width: 112px;margin-left: 40px;}
  .sixth{width: 120px;margin-left: 40px;}
}
li:nth-child(n+2):hover{color: #199ff8}
.el-button{width: 200px;font-size: 16px;border-radius: 5px;background-color: #ECF6FF;margin-top: 30px;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .hzxmKCPList {width: 100vw;}
  .box{width: 100%;}
  .recommendation, .mining{margin-left: 2vw;}
  ul{width: 100vw;
    li:nth-child(1){
      .first{width: 74vw; margin-left: .1rem;}
      .second{width:20vw; margin-left:0;}
    }
    li:nth-child(n+2){
      .first{width: 3rem;}
      .second{width: .4rem; margin-left: .3rem;}
    }
  }
}
</style>

<template>
  <div class="hzxmKCPList">
    <div class="box">
      <div class="recommendation">
        <i class="iconfont icon-rementuijian" />
        <span>热门推荐 / Popular recommendation</span>
      </div>
      <div class="swipergroup">
        <SwiperGroup :swiperGroupList="swiperGroupList" @clickSwiper="goDetails"></SwiperGroup>
      </div>
      <div class="mining">
        <i class="iconfont icon-xiangmuwenjian" />
        <span>矿产品 / Mineral products</span>
      </div>
      <div class="search">
        <SearchBarKCP @searchdata="search"></SearchBarKCP>
      </div>
      <ul>
        <li>
          <div class="first">产品名称</div>
          <div class="second">交易类型</div>
          <div class="third">产品类型</div>
          <div class="fourth">矿产种类</div>
          <div class="fifth">价格</div>
          <div class="sixth">更新时间</div>
        </li>
        <li v-for="(item,index) in items" :key="index" @click="goDetailsP(item)">
          <div class="first"> {{ item.title }} </div>
          <div class="second"> {{  item.typeid | formatJYLX() }} </div>
          <div class="third"> {{ item.dispc }} </div>
          <div class="fourth"> {{ item.kuangchanzhonglei }} </div>
          <div class="fifth"> {{ item.jiaoyijiage }} </div>
          <div class="sixth"> {{ item.edittime * 1000 | formatDate() }} </div>
        </li>
      </ul>
      <el-button @click="getOthers" :disabled="moreLength <= 0">加载更多</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 合作项目下的矿产品专场列表页面
 */
import SwiperGroup from '../assembly/SwiperGroup.vue'
import SearchBarKCP from '../assembly/SearchBarKCP.vue'
import arrayFun from '../method/array'
import filters from '../method/filter.js'
export default {
  name: '',
  components:
  {
    SwiperGroup,
    SearchBarKCP
  },
  mixins: [filters],
  data()
  {
    return {
      swiperGroupList: [],
      projectsList: [],
      num: null,
      items: [],
      moreLength: null
    }
  },
  created()
  {
    this.getKcp()
    this.search(['', '', '', '', ''])
  },
  methods:
  {
    getKcp()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 14, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupList = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, company: item.company, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, type: item.typeid, species: item.catid, category: item.kuangchanzhonglei, price: item.jiaoyijiage, time: item.adddate, ssgj: item.ssgj})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupList.push(tempList[i])
      })
    },
    // 根据搜索条件获取数据
    search(arr)   //val 交易类型   val2 产品类型   val3 矿产种类   val4 国家   val5 输入关键词
    {
      //筛选条件
      let exp = ''
      if (arr[0] !== '')
        exp += `A.typeid = '${arr[0]}' and `
      if (arr[1] !== '')
        exp += `A.catid = ${arr[1]} and `
      if (arr[2] !== '')
        exp += `A.kuangchanzhonglei = '${arr[2]}' and `
      if (arr[3] !== '')
        exp += `A.ssgj = ${arr[3]} and `
      if (arr[4] !== '')
        exp += `A.title like '%${arr[4]}%' and A.examine = 0 and `
      exp = exp ? `${exp}A.id != 0 and A.examine = 0` : 'A.id>0 and A.examine = 0'
      let paras = {cmd: 'queryUnion', _major: 11, _minor: 14, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: exp + ' and A.catid=B.id', init: 0, pageno: 1, pagesize: 100, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        // 过滤之后的数据
        this.projectsList = ret[0].data
        this.moreLength = this.projectsList.length
        // 初始化页面数据
        this.items = []
        if (this.projectsList.length >= 10)
        {
          for (let i = 0; i < 10; i++)
          {
            this.items.push(this.projectsList[i])
            this.moreLength -= 1
          }
        }
        else
        {
          for (let i = 0; i < this.projectsList.length; i++)
          {
            this.items.push(this.projectsList[i])
            this.moreLength -= 1
          }
        }
        this.num = 0
      })
    },
    // 加载更多
    getOthers()
    {
      this.num += 1
      if (this.projectsList.length - 10 * this.num >= 10)
      {
        for (let i = 0; i < 10; i++)
        {
          this.items.push(this.projectsList[i + 10 * this.num])
          this.moreLength -= 1
        }
      }
      else
      {
        for (let i = 0; i < this.projectsList.length - 10 * this.num; i++)
        {
          this.items.push(this.projectsList[i + 10 * this.num])
          this.moreLength -= 1
        }
      }
    },
    // 跳转到矿产品的详细信息页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    goDetailsP(item)
    {
      let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/HzxmKCPList.vue